import React, { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import {
  setOrigenMultitab,
  setPasoMultiTab,
} from "../../../context/Actions/multiTab/multiTab";
import "./MultitabHome.css";
import { GlobalContext } from "../../../../global/context/Provider";

const MultitabHome = ({ tabs, width, desactivar, onClick }) => {
  const { multiTabState, multiTabDispatch } = useContext(PortalContext);
  const { configState } = useContext(GlobalContext);

  const [numActivo, setNumActivo] = useState(0);
  const [tresItems, setTresItems] = useState(false);
  const [dosItems, setDosItems] = useState(false);

  const activarPestania = (num, desactivar, item) => {
    onClick(item);
    if (desactivar !== undefined) {
      if (tabs[num].nombre !== tabs[desactivar].nombre) {
        setPasoMultiTab(num)(multiTabDispatch);
      }
    } else {
      setOrigenMultitab(null)(multiTabDispatch);
      setPasoMultiTab(num)(multiTabDispatch);
    }
  };

  useEffect(() => {
    const urlActual = window.location.pathname;
    if (urlActual === "/consultamedica") {
      setNumActivo(0);
    } else if (urlActual === "/estudios") {
      setNumActivo(1);
    } else if (urlActual === "/laboratorio" || urlActual === "/testpcr") {
      setNumActivo(2);
    } else if (urlActual === "/recetasdigitales") {
      setNumActivo(3);
    }
  }, [multiTabState]);

  useEffect(() => {
    if (configState.config.data !== null) {
      if (configState.config.data.opcLaboratorio === false) {
        setTresItems(true);
      }
      if (configState.config.data.opcRecetaDigital === false) {
        setTresItems(true);
      }
      if (
        (configState.config.data.opcRecetaDigital === false &&
          configState.config.data.opcLaboratorio === false) ||
        configState.config.data.opcBuscadorTurnos
      ) {
        setTresItems(false);
        setDosItems(true);
      }
    }
  }, [multiTabState, configState.config.data]);

  return (
    <React.Fragment>
      <div
        className={
          tresItems
            ? "contenedor-multitabTres-home bgc-grey95"
            : dosItems
            ? "contenedor-multitabDos-home bgc-grey95"
            : "contenedor-multitab-home bgc-grey95"
        }
      >
        {Array.isArray(tabs) &&
          tabs.length > 0 &&
          tabs.map((item, index) => {
            return item.id === 4 ? (
              ""
            ) : (
              <div
                className={`pestania  ${
                  numActivo === item.id ? "bgc-latex10" : "usarHover"
                }`}
                onClick={() => activarPestania(index, desactivar, item)}
                key={index}
              >
                {numActivo === item.id && (
                  <div className="flecha bgc-latex10"></div>
                )}
                <div className="multitab-home-titulo">
                  <h2
                    className={`m-0 rb18m textCenter ${
                      numActivo === item.id ? "c-white" : "c-black10"
                    } ${
                      item.nombre === "Datos personales" ? "tituloMobileV2" : ""
                    }`}
                  >
                    {item.nombre}
                  </h2>
                </div>
              </div>
            );
          })}
      </div>
    </React.Fragment>
  );
};
export default MultitabHome;
